import { INTEGRATION_KEY } from "../../state/integration/Constants"

export const PRODUCT_PRICE_UPDATE_STATUS = {
    MODIFIED: "modified" as const,
    DELETED: "deleted" as const
}

export const INTEGRATIONS_SUPPORTING_PRODUCT_PRICES = [INTEGRATION_KEY.LIGHTSPEED_RETAIL,INTEGRATION_KEY.VEND]


// WEBPACK FOOTER //
// ./src/utils/product-price/constant.ts